import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MaterialSharedModule } from '@app/shared/modules/material-shared.module';
import { TranslateService } from '@ngx-translate/core';

export interface SessionEndedDialogData {
  title: string;
  message: string;
  iconName: string;
  showRestartOption?: boolean;
  restartButtonText?: string;
  closeButtonText?: string;
}

export interface SessionEndedDialogResult {
  action: 'restart' | 'close';
}

@Component({
  selector: 'app-session-ended-dialog',
  templateUrl: './session-ended-dialog.component.html',
  styleUrls: ['./session-ended-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MaterialSharedModule
  ]
})
export class SessionEndedDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SessionEndedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SessionEndedDialogData,
    private translate: TranslateService
  ) {
    // Set defaults if not provided
    this.data.showRestartOption = this.data.showRestartOption ?? true;
    this.data.restartButtonText = this.data.restartButtonText || this.translate.instant('sessionEndedDialog.restart');
    this.data.closeButtonText = this.data.closeButtonText || this.translate.instant('sessionEndedDialog.close');
  }

  onClose(): void {
    this.dialogRef.close({ action: 'close' });
  }

  onRestart(): void {
    this.dialogRef.close({ action: 'restart' });
  }
}
